export interface DateRes {
  dateRange: string;
  dateArray: string[];
}

export class Tool {
  static stringLength (str: string, num: number) {
    if (str.length > num) {
      return str.substr(0, num) + '...'
    }
    return str
  }

  static dateFormat (date: Date) {
    const fdate = new Date(date)
    const year = fdate.getFullYear()
    const month = (fdate.getMonth() + 1) < 10 ? '0' + (fdate.getMonth() + 1) : (fdate.getMonth() + 1)
    const day = (fdate.getDate()) < 10 ? '0' + fdate.getDate() : fdate.getDate()
    const resDate = year + '-' + month + '-' + day
    if (resDate === '1-1-1') {
      return ''
    }
    return resDate
  }

  static sortBy (field: string, order: boolean) {
    return function (o: any, p: any) {
      const a: number = o[field]
      const b: number = p[field]
      if (a === b) {
        return 0
      }
      if (typeof a === typeof b) {
        if (order === true) {
          return a < b ? 1 : -1
        } else {
          return a < b ? -1 : 1
        }
      }
      if (order === true) {
        return typeof a < typeof b ? 1 : -1
      } else {
        return typeof a < typeof b ? -1 : 1
      }
    }
  }

  // 按周排日期
  static getDateRes (start: Date, end: Date) {
    const weekStart = this.weekDate(start, 'start')
    const weekEnd = this.weekDate(end, 'end')
    const resultArr: Array<DateRes> = []
    if (weekStart && weekEnd) {
      let startDate = weekStart
      const week = this.countingWeek(weekStart, weekEnd)
      for (let i = 1; i <= week; i++) {
        const s = this.formatDate(startDate)
        const e = this.formatDate(startDate.getTime() + (1000 * 3600 * 24 * 6))
        const dateArray = this.getRangeDate(7, startDate)
        const key = s + '~' + e
        const dateRes: DateRes = {
          dateRange: key,
          dateArray: dateArray
        }
        startDate = new Date(startDate.getTime() + (1000 * 3600 * 24 * 7))
        resultArr.push(dateRes)
      }
    }

    return resultArr
  }

  // 按月排日期
  static getMonthDateRes (start: Date, end: Date) {
    const monthStart = new Date(this.formatMonth(start))
    const monthEnd = new Date(this.formatMonth(end))
    const resultArr: Array<DateRes> = []
    if (monthStart && monthEnd) {
      let startMonth = monthStart
      const month = this.countingMonth(monthStart, monthEnd)
      for (let i = 1; i <= month; i++) {
        const s = this.formatMonth(startMonth)
        const dateArray = this.getMonthRangeDate(startMonth)
        const key = s
        const dateRes: DateRes = {
          dateRange: key,
          dateArray: dateArray
        }
        startMonth = this.nextMonth(startMonth)
        resultArr.push(dateRes)
      }
    }

    return resultArr
  }

  static weekDate (t: Date, ty: string) {
    switch (t.getUTCDay()) {
      case 0:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 6))
        }
        return t
      case 1:
        if (ty === 'start') {
          return t
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 6))
      case 2:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 1))
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 5))
      case 3:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 2))
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 4))
      case 4:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 3))
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 3))
      case 5:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 4))
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 2))
      case 6:
        if (ty === 'start') {
          return new Date(t.getTime() - (1000 * 3600 * 24 * 5))
        }
        return new Date(t.getTime() + (1000 * 3600 * 24 * 1))
    }
  }

  static getRangeDate (range: number, t: Date) {
    const resultArr: Array<any> = []
    if (range) {
      if (range < 0) {
        const st = t.getTime() + (1000 * 3600 * 24)
        for (let i = Math.abs(range); i >= 0; i--) {
          resultArr.push(this.formatDate(st + (-1000 * 3600 * 24 * i)))
        }
      } else {
        const st = t.getTime() - (1000 * 3600 * 24)
        for (let i = 1; i <= range; i++) {
          resultArr.push(this.formatDate(st + (1000 * 3600 * 24 * i)))
        }
      }
    }
    return resultArr
  }

  static getMonthRangeDate (t: Date) {
    const resultArr: Array<string> = []
    const nextMonth = this.nextMonth(t)
    const day = this.countingMonthDays(t, nextMonth)
    let start = t.getTime()
    for (let i = 1; i < day; i++) {
      start += 1000 * 3600 * 24
      resultArr.push(this.formatDate(start))
    }
    return resultArr
  }

  static formatDate (time: any) {
    // 格式化日期，获取今天的日期
    const Dates = new Date(time)
    const year: number = Dates.getFullYear()
    const month: any = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1)
    const day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate()
    return year + '-' + month + '-' + day
  }

  static formatMonth (time: any) {
    const Dates = new Date(time)
    const year: number = Dates.getFullYear()
    const month = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1)
    return year + '-' + month
  }

  // 下个月
  static nextMonth (t: Date) {
    const Dates = new Date(t)
    let year: number = Dates.getFullYear()
    let month: number = Dates.getMonth() + 2
    if (month > 12) {
      year += 1
      month = 1
    }
    const temp: any = month < 10 ? '0' + month : month

    return new Date(year + '-' + temp)
  }

  static countingWeek (start: Date, end: Date) {
    return ((new Date(this.formatDate(end)).getTime() - new Date(this.formatDate(start)).getTime()) / (1000 * 3600 * 24) + 1) / 7
  }

  static countingMonth (start: Date, end: Date) {
    const startDates = new Date(start)
    const endDates = new Date(end)
    const startYear: number = startDates.getFullYear()
    const endYear: number = endDates.getFullYear()
    const startMonth = startDates.getMonth() + 1
    const endMonth = endDates.getMonth() + 1
    return (endYear - startYear) * 12 + (endMonth - startMonth) + 1
  }

  static countingDays (start: Date, end: Date) {
    return (new Date(this.formatDate(end)).getTime() - new Date(this.formatDate(start)).getTime()) / (1000 * 3600 * 24) + 1
  }

  static countingMonthDays (start: Date, end: Date) {
    return (new Date(this.formatDate(end)).getTime() - new Date(this.formatDate(start)).getTime()) / (1000 * 3600 * 24)
  }
}
